import { observable, action } from 'mobx'
import request from 'app/vendor/request'
import config from 'app/config'
import { message } from 'antd'

export default class Store {
  @observable groupId = ""
  @observable recoveryTableData = []
  @observable tableData = []
  @observable list
  @observable detailData = {}

  @action getGroupListById = (groupId, query) => {
    return request.get(`${config.backend}/pgs/groups/${groupId}/reports?state=${query}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.recoveryTableData = res
        }
      )
  }

  @action clearRecoveryTableData = () => {
    this.recoveryTableData = []
  }

  @action setGroupId = (id) => {
    this.groupId = id
  }

  @action initTableData = () => {
    return request.get(`${config.backend}/science/pgs/groups/${this.groupId}/reports`)
      .checkToken()
      .commonDispose()
  }

  @action updateTableData = (data) => {
    this.tableData = data
  }

  @action getDetailData = (reportId) => {
    return request.get(`${config.backend}/pgs/reports/${reportId}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData = res
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action clearDetailData = () => {
    this.detailData = {}
  }

  static fromJS() {
    const store = new Store()
    return store
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/research/pgs/report.js